import React from "react";
import { Box, Typography } from "@mui/material";

interface SectionTitleProps {
    title: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title }) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ my: 3 }} // Optionnel : marge verticale
        >
            <Box
                sx={{
                    flex: 1,
                    borderBottom: "2px solid #FF9800" // couleur orange
                }}
            />
            <Typography variant="h5" component="span" sx={{ mx: 3 }}>
                {title}
            </Typography>
            <Box
                sx={{
                    flex: 1,
                    borderBottom: "2px solid #FF9800"
                }}
            />
        </Box>
    );
};

export default SectionTitle;